module.exports = __webpack_public_path__ + "static/html5-664a8c00ef526bf33edf55808601d461.png";